module.exports = {
  title: 'Page title',
  meta: 'Meta info',
};
